import React, { useState } from 'react'
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { changePassword } from '../../Redux/actions/customer';
import { useHistory } from 'react-router';
import Header from '../../Components/Header';
import GoBack from '../BackButton/GoBack';
import { useTranslation } from 'react-i18next';

function ChangePassword(props: any) {
    const history = useHistory();
    const [showPassword, setShowPassword] = useState(false);
    const [confirmshowPassword, setConfirmShowPassword] = useState(false);
    const [passwordError, setPasswordError] = useState(false)
    const [confirmPasswordError, setConfirmPasswordError] = useState(false)
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [disable, setDisable] = useState(true);
    const { t } = useTranslation();

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

    const handleshowTogglePassword = () => {
        setConfirmShowPassword(!confirmshowPassword);
    };
    const handlePassword = (e: any) => {
        setPassword(e.target.value)
        if (e.target.value.length < 8) {
            setPasswordError(true)
        }
        else {
            setPasswordError(false)
        }
        if (e.target.value != confirmPassword) {
            setDisable(true)
        }
        else {
            setDisable(false)
            setConfirmPasswordError(false)
        }

    }
    const handleConfirmPassword = (e: any) => {
        setConfirmPassword(e.target.value)
        if (password != e.target.value) {
            setConfirmPasswordError(true)
        }
        else {
            setConfirmPasswordError(false)
            setDisable(false)

        }


    }
    const handleEnterPress = (e: any) => {
        if (e.key == "Enter" && !passwordError && !confirmPasswordError)
            handleSubmit();

        else if (e.key == "Enter")
            toast.error(t("FILL_ALL_FIELDS"))

    }
    const handleSubmit = () => {
        props.changePassword(password, history)
    }
    return (
        <div className='login-container chnage-password'>
            <Header />
            <div className='login-field'>
                <div className='welcome-login px-5'>
                    <div className='d-flex align-items-center gap-10 web-backbtn'>
                        <GoBack/>
                        <h3>{t("CHANGE_PASSWORD")}</h3>
                    </div>
                    <div className="col-md-12 mt-3">
                        <div className='position-relative'>
                            <TextField

                                value={password}
                                onChange={handlePassword}
                                onKeyPress={handleEnterPress}
                                helperText={passwordError ? t("PASSWORD_LENGTH_ERROR") : ''}
                                name="input2"
                                className='field-style text-error' type={showPassword ? 'text' : 'password'} autoComplete="new-password" label={<div className='font-normal d-flex gap-1'><p>{t("PASSWORD")}</p><p className='color-theme h4'>*</p></div>} variant="filled" color="error" />
                            <Button onClick={handleTogglePassword} className='eye-btn' color="error"><i className={showPassword ? 'ri-eye-off-fill' : 'ri-eye-fill'}></i></Button>
                        </div>
                    </div>
                    <div className="col-md-12 mt-4">
                        <div className='position-relative'>
                            <TextField
                                value={confirmPassword}
                                onChange={handleConfirmPassword}
                                onKeyPress={handleEnterPress}
                                helperText={confirmPasswordError ? t("PASSWORD_MATCH_ERROR") : ''}
                                name="input2"
                                className='field-style text-error' type={confirmshowPassword ? 'text' : 'password'} autoComplete="new-password" label={<div className='font-normal d-flex gap-1'><p>{t("CONFIRM_PASSWORD")}</p><p className='color-theme h4'>*</p></div>} variant="filled" color="error" />
                            <Button onClick={handleshowTogglePassword} className='eye-btn' color="error"><i className={confirmshowPassword ? 'ri-eye-off-fill' : 'ri-eye-fill'}></i></Button>
                        </div>
                    </div>
                    <Button onClick={handleSubmit} disabled={(disable || passwordError || confirmPasswordError) ? true : false} className={`w-100 font-medium mt-4 fblogin ${(disable || passwordError || confirmPasswordError) ? "disable-btn" : "able-btn"}`} variant="contained" color="error">{t("CONFIRM")}</Button>
                </div>
            </div>
        </div>
    )
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        changePassword: function (newPass: any, history?: any) {
            dispatch(changePassword(newPass, history));
        }
    }
}
export default connect(null, mapDispatchToProps)(ChangePassword);
